const weekOptions = [
    {
        key: -1,
        text: "All",
        value: -1,
    },
    {
        key: 0,
        text: "This Week",
        value: 0,
    },
    {
        key: 1,
        text: "Last Week",
        value: 1,
    },
    {
        key: 2,
        text: "Two Weeks Ago",
        value: 2,
    },
    {
        key: 3,
        text: "Three Weeks Ago",
        value: 3,
    },
    {
        key: 4,
        text: "Four Weeks Ago",
        value: 4,
    },
    {
        key: 5,
        text: "Five Weeks Ago",
        value: 5,
    },
    {
        key: 6,
        text: "Six Weeks Ago",
        value: 6,
    },
    {
        key: 7,
        text: "Seven Weeks Ago",
        value: 7,
    },
    {
        key: 8,
        text: "Eight Weeks Ago",
        value: 8,
    },
    {
        key: 9,
        text: "Nine Weeks Ago",
        value: 9,
    },
    {
        key: 10,
        text: "Ten Weeks Ago",
        value: 10,
    },
];

export default weekOptions;
